import { useState, useRef, useMemo } from 'react';
import { u as usePopper } from '../3rdPartyModules/react-popper/lib/esm/usePopper-DuBsalaq.js';
import { t as textDirectionSensitiveFn } from './popoverModifiers/textDirectionSensitive-CsCfX-rl.js';
import { c as calculateOffsetSkidding } from './popoverModifiers/calculateOffsetSkidding-CkO4n-_x.js';

function useInlinePopover(options) {
  const {
    placement,
    offsetDistance = 0,
    offsetSkidding = 0,
    enableFlip,
    preventOverflow,
    boundaryRef,
    strategy,
    rootBoundary = 'document',
    withArrow
  } = options;
  const [triggerElement, setTriggerElement] = useState(null);
  const [popoverElement, setPopoverElement] = useState(null);
  const arrowElementRef = useRef(null);
  const offsetModifier = useMemo(() => ({
    name: 'offset',
    options: {
      offset: ({
        placement: popoverPlacement
      }) => {
        const distance = withArrow ? 10 + offsetDistance : offsetDistance;
        const skidding = calculateOffsetSkidding(withArrow, popoverPlacement, distance, offsetSkidding);
        return [skidding, distance];
      }
    }
  }), [withArrow, offsetDistance, offsetSkidding]);
  const {
    styles,
    attributes,
    update
  } = usePopper(triggerElement, popoverElement, {
    placement,
    modifiers: [{
      name: 'textDirectionSensitive',
      enabled: true,
      phase: 'beforeRead',
      fn: textDirectionSensitiveFn
    }, ...(/left|right/.test(placement) ? [{
      name: 'flip',
      enabled: enableFlip,
      options: {
        rootBoundary,
        ...((boundaryRef === null || boundaryRef === void 0 ? void 0 : boundaryRef.current) && {
          boundary: boundaryRef.current
        })
      }
    }] : [{
      name: 'flip',
      enabled: enableFlip,
      options: {
        rootBoundary,
        ...((boundaryRef === null || boundaryRef === void 0 ? void 0 : boundaryRef.current) && {
          boundary: boundaryRef.current
        })
      }
    }]), offsetModifier, {
      name: 'arrow',
      options: {
        element: arrowElementRef.current
      }
    }, {
      name: 'preventOverflow',
      ...(preventOverflow && {
        options: {
          ...preventOverflow,
          ...((boundaryRef === null || boundaryRef === void 0 ? void 0 : boundaryRef.current) && {
            boundary: boundaryRef.current
          })
        }
      })
    }],
    strategy
  });
  return {
    styles,
    attributes,
    triggerElement,
    popoverElement,
    arrowElementRef,
    setTriggerElement,
    setPopoverElement,
    update
  };
}

export { useInlinePopover as u };
//# sourceMappingURL=useInlinePopover-D_iJ07xC.js.map
